module.exports = __webpack_public_path__ + "static/media/main_background@2x.f31483d5.png";